import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import ContactUs from "../../Components/Popup/ContactUs";
import imagePath from "../../constants/imagePath";
import {
  AboutQuote,
  AnalyticsAndPayments,
  AndroidIcon,
  AndroidService,
  Angular,
  ArrowRight,
  BackendDatabase,
  CloudIcon,
  Figma,
  HybridService,
  Img01,
  Img02,
  Img03,
  Img04,
  Img05,
  Img06,
  MobileTechnologies,
  NodeJS,
  ReactNativeIcon,
  ServiceIos,
  UIUX,
  WebHybrid,
} from "../../constants/svgPath";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Mousewheel, Keyboard } from "swiper/modules";
import { servicesContent } from "../../utils/ServiceData";

const DynamicImgComp = [Img01, Img02, Img03, Img04, Img05, Img06];

function ServicesDetails() {
  const { slug } = useParams();
  const pageData = servicesContent[slug ?? "android-app-development"];

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState<number | null>(0);
  const [selectedEndToEndService, setSelectedEndToEndService] = useState(
    pageData?.endToEndServices?.setps[0],
  );
  const [selectedTechStack, setSelectedTechStack] = useState(
    pageData?.techStacks?.techList[0],
  );

  const handleClick = (index: number) => {
    setActiveIndex(index);
  };

  // Services list for the selectable end section
  const [serviceIndex, setServiceIndex] = useState(0);
  const handleServiceClick = (index: number) => {
    setServiceIndex(index);
  };

  useEffect(() => {
    if (isPopupOpen) {
      document.body.classList.add("body_active");
    } else {
      document.body.classList.remove("body_active");
    }
  }, [isPopupOpen]);

  // Safely select the current service to avoid TS2532 (possibly undefined index)

  // Innovative tech stack: dynamic options and selected index
  const [innoIndex, setInnoIndex] = useState(0);
  interface InnoTech {
    name: string;
    img?: string;
    icon?: JSX.Element;
  }
  interface InnoOption {
    title: string;
    icon: JSX.Element;
    techs: InnoTech[];
  }

  const toggleFaq = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <section className="aboutbg services_sec services_sec_layered">
        {/* Bottom layer: actual content image */}
        {pageData?.banner?.backgroundImage && (
          <div
            className="services_sec_content_bg"
            style={{
              backgroundImage: `url(${pageData.banner.backgroundImage})`,
            }}
            aria-hidden
          />
        )}
        {/* Overlay: black film / overlay image for text readability */}
        <div
          className="services_sec_overlay_bg"
          style={{
            backgroundImage: `url(${imagePath.top_overlay})`,
          }}
          aria-hidden
        />
        <div className="contair services_sec_content">
          <div className="banner_left">
            {/* <div className="bread">
              <Link to="/">Home </Link>
              <Link to="/news-insights"> / Services </Link>{" "}
              <span>/ {pageData?.banner?.breadcrumb} </span>
            </div> */}

            <h1>
              {pageData?.banner?.title}
              <span className="blk"> {pageData?.banner?.highlight}</span>
            </h1>
            <p className="banner_txt">{pageData?.banner?.description}</p>
            <button
              type="button"
              onClick={() => setIsPopupOpen(true)}
              className="btn_common btn_primry"
            >
              {pageData?.banner?.cta}
            </button>
          </div>
        </div>
      </section>

      <section className="specliz_sec common_padd">
        <div className="contair">
          <div className="heading">
            <h2>{pageData?.whyPartenrChoose?.title}</h2>
            <p>{pageData?.whyPartenrChoose?.description}</p>
          </div>
          {pageData?.whyPartenrChoose?.milestones.length > 0 && (
            <ul className="specliz_mn">
              {pageData?.whyPartenrChoose?.milestones?.map((item, index) => {
                return (
                  <li className="specliz_pt">
                    <h3>
                      {item?.counts}{" "}
                      {typeof item?.counts == "number" && (
                        <span>{index == 1 ? "%" : "+"}</span>
                      )}
                    </h3>
                    <p>{item?.description}</p>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </section>

      <section className="end_sec common_padd">
        <div className="end_inr">
          <div className="contair">
            <div className="next_heading end_flx">
              <h2>{pageData?.endToEndServices?.title}</h2>
              <p>{pageData?.endToEndServices?.description}</p>
            </div>
          </div>
          <div className="end_sod_inr">
            <div className="end_sod_cont">
              <div className="end_l">
                <ul className="logis_list">
                  {pageData?.endToEndServices.setps.map((s, idx) => (
                    <li
                      key={s.title}
                      className={`logis_pt ${
                        serviceIndex === idx ? "active" : ""
                      }`}
                      onClick={() => {
                        handleServiceClick(idx);
                        setSelectedEndToEndService(s);
                      }}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ")
                          handleServiceClick(idx);
                      }}
                    >
                      <span>{String(idx + 1).padStart(2, "0")}</span>
                      <h3>{s.title}</h3>
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className="end_r"
                style={
                  {
                    // backgroundImage: `url(${pageData.endToEndServices.image})`,
                  }
                }
              >
                <div className="end_bg end_cmn">
                  {/* Primary box - shows main icon/title/paragraph for selected service */}
                  <div className={`end_box android`}>
                    {/* <span>{selectedEndToEndService.icon}</span> */}
                    <h2>{selectedEndToEndService.title}</h2>
                    <p>{selectedEndToEndService.description}</p>
                  </div>

                  {/* Secondary box - shows bullets if present, otherwise two summary blocks */}
                  <div className="end_box ios">
                    {selectedEndToEndService?.bullets &&
                      selectedEndToEndService?.bullets.map((b, i) => (
                        <div className="end_sb" key={i}>
                          <h2>• {b.title}</h2>
                          <p>{b.text}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="trans_form_sec common_padd img_stle"
        style={{
          backgroundImage: `url(${pageData.transformYourBussiness.image})`,
        }}
      >
        <div className="contair">
          <div className="hire_mn">
            <div className="heading txt_l">
              <h2>{pageData?.transformYourBussiness?.title}</h2>
            </div>
            <div className="client_btn">
              <button
                type="button"
                onClick={() => setIsPopupOpen(true)}
                className="btn_common btn_primry"
              >
                Hire Our Developer Now!
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="rade_sec common_padd">
        <div className="contair">
          <div className="heading">
            <h2>{pageData?.developmentProcessSteps?.title}</h2>
            <p>{pageData?.developmentProcessSteps?.description}</p>
          </div>
          <ul className="rade_flx">
            {pageData?.developmentProcessSteps?.setps?.map((step, index) => {
              const SvgIcon = DynamicImgComp[index];
              return (
                <li className="rade_pt">
                  <figure className="">
                    <SvgIcon />
                  </figure>
                  <h3>{step?.title}</h3>
                  <p>{step?.description}</p>
                </li>
              );
            })}
          </ul>
          <div className="client_btn">
            <button
              type="button"
              onClick={() => setIsPopupOpen(true)}
              className="btn_common btn_primry"
            >
              {pageData?.developmentProcessSteps?.cta}
            </button>
          </div>
        </div>
      </section>
      <section className="mbl_sec top_padd">
        <div className="contair">
          <div className="heading">
            <h2> {pageData?.customIndustries?.title}</h2>
            <p>{pageData?.customIndustries?.description}</p>
          </div>
          <ul className="mbl_flx">
            {pageData?.customIndustries?.industries?.map((industry) => {
              return (
                <li className="mbl_pt">
                  <figure className="">
                    <img src={industry?.image} alt="" />
                  </figure>
                  <h3>{industry?.title}</h3>
                </li>
              );
            })}
          </ul>
        </div>
      </section>
      {/* <section className="impact_sec common_padd">
        <div className="contair">
          <div className="heading">
            <h2>{pageData?.serviceImpacts?.title}</h2>
            <p>{pageData?.serviceImpacts?.description}</p>
          </div>
          <Swiper
            modules={[Navigation, Pagination, Mousewheel, Keyboard]}
            cssMode={true}
            navigation={{
              enabled: true,
            }}
            pagination={false}
            keyboard={true}
            slidesPerView={1}
            spaceBetween={10}
            grabCursor={true}
            className="impact_sld"
          >
            {pageData?.serviceImpacts?.slides?.map((impact) => {
              return (
                <SwiperSlide className="">
                  <div className="impact_flx">
                    <div className="impact_l">
                      <h3>{impact?.title}</h3>
                      <h4>{impact?.subTitle}</h4>
                      <p>{impact?.description}</p>
                      <h5>Technologies Used:</h5>
                      <ul className="impact_lst">
                        {impact?.technologiesUsed?.map((tech) => {
                          return (
                            <li className="impact_pt common_border">
                              <span>
                                <ReactNativeIcon />
                              </span>{" "}
                              <h6>{tech?.title}</h6>
                            </li>
                          );
                        })}
                      </ul>
                      <div className="client_btn">
                        <button
                          type="button"
                          onClick={() => setIsPopupOpen(true)}
                          className="btn_common btn_primry"
                        >
                          Get Consultation
                        </button>
                      </div>
                    </div>
                    <div className="impact_r">
                      <figure>
                        <img src={impact?.image} alt="" />
                      </figure>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </section> */}

      <section className="service_why_sec common_padd">
        <div className="contair">
          <div className="service_why_mn">
            <figure className="service_why_l">
              <img src={pageData?.whyChooseUs.image} alt="" />
            </figure>

            <div className="service_why_r">
              <div className="next_heading txt_l">
                <h2>{pageData?.whyChooseUs?.title}</h2>
                <p>{pageData?.whyChooseUs?.description}</p>
              </div>
              <ul className="service_why_lst">
                {pageData?.whyChooseUs?.steps.map((item, index) => (
                  <li
                    key={index}
                    className={`service_why_pt ${
                      activeIndex === index ? "active" : ""
                    }`}
                    onClick={() => handleClick(index)}
                  >
                    <button
                      style={{ minWidth: 100, wordBreak: "break-word" }}
                      type="button"
                    >
                      {item.title}
                    </button>
                    <p>{item.text}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="pride_sec common_padd">
        <div className="contair">
          <div className="heading">
            <h2>{pageData?.serviceTestimonials?.title}</h2>
            <p>{pageData?.serviceTestimonials?.description}</p>
          </div>
          <div className="pride_flx">
            <Swiper
              modules={[Navigation, Pagination, Mousewheel, Keyboard]}
              cssMode={true}
              navigation={{
                enabled: true,
              }}
              pagination={true}
              keyboard={true}
              slidesPerView={1}
              spaceBetween={10}
              grabCursor={true}
              className="pride_sld"
            >
              {pageData?.serviceTestimonials?.clientTestimonails?.map(
                (testimonial) => {
                  return (
                    <SwiperSlide>
                      <div className="pride_bx">
                        <span>
                          {" "}
                          <AboutQuote />{" "}
                        </span>

                        <p className="pride_tx">{testimonial?.description}</p>
                        <h3>{testimonial?.name}</h3>
                        <p className="pride_postn">{testimonial?.position}</p>
                      </div>
                    </SwiperSlide>
                  );
                },
              )}
            </Swiper>
          </div>
        </div>
      </section> */}
      {/* <section className="next_sec inno_sec ">
        <div className="contair ">
          <div className="next_heading">
            <h2>{pageData?.techStacks?.title}</h2>
            <p>{pageData?.techStacks?.description}</p>
          </div>
          <div className="next_inr">
            <div className="next_l">
              <ul className="next_list">
                {pageData?.techStacks.techList.map((opt, idx) => (
                  <li
                    key={opt.name}
                    className={`next_link ${innoIndex === idx ? "active" : ""}`}
                    onClick={() => {
                      setInnoIndex(idx);
                      setSelectedTechStack(opt);
                    }}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") setInnoIndex(idx);
                    }}
                  >
                    <Link className="hrf_link" to="">
                      <span>{opt.icon} </span> {opt.name}
                    </Link>
                    <div className="inno_img">
                      <ul className="inno_list">
                        {opt.lenguages.map((t) => (
                          <li className="inno_pt common_border" key={t.name}>
                            <figure>
                              {t.icon ? (
                                <img src={t.icon} alt={t.name} />
                              ) : t.icon ? (
                                t.icon
                              ) : (
                                <div className="tech_placeholder">
                                  {t.name[0]}
                                </div>
                              )}
                            </figure>
                            <h3>{t.name}</h3>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="inno_r">
              <div className="inno_img">
                <ul className="inno_list">
                  {selectedTechStack.lenguages.map((t) => (
                    <li className="inno_pt common_border" key={t.name}>
                      <figure>
                        {t.icon ? (
                          <img src={t.icon} alt={t.name} />
                        ) : t.icon ? (
                          t.icon
                        ) : (
                          <div className="tech_placeholder">{t.name[0]}</div>
                        )}
                      </figure>
                      <h3>{t.name}</h3>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section className="fre_sec common_padd">
        <div className="contair">
          <div className="heading">
            <h2>{pageData?.faqs?.title}</h2>
            <p>{pageData?.faqs?.description}</p>
          </div>
          <div className="fre_inr">
            {pageData?.faqs?.questions.map((item, index: number) => (
              <div
                key={index}
                className={`fre_flx ${activeIndex === index ? "active" : ""}`}
              >
                <button
                  type="button"
                  className="fre_bx"
                  onClick={() => toggleFaq(index)}
                >
                  <h3>{item.title}</h3>
                  <span>
                    <ArrowRight />
                  </span>
                </button>
                <div className="fre_dis">
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
            {/*       
            <div className="fre_flx">
              <button type="button" className="fre_bx">
                <h3>How long does it take to build an Android app?</h3>
                <span><ArrowRight /></span>
              </button>
              <div className="fre_dis">
                <p>Simple app: 4–8 weeks</p>
                <p>Medium complexity: 2–4 months</p>
                <p>Enterprise-grade/complex: 4–8+ months (depending on features and integrations)</p>
              </div>
            </div>
              <div className="fre_flx">
              <button type="button" className="fre_bx">
                <h3>How much does Android app development cost?</h3>
                <span><ArrowRight /></span>
              </button>
              <div className="fre_dis">
                <p>Simple app: 4–8 weeks</p>
                <p>Medium complexity: 2–4 months</p>
                <p>Enterprise-grade/complex: 4–8+ months (depending on features and integrations)</p>
              </div>
            </div> */}
            {/* {faqData.map((faq, index) => (
    <div
      key={index}   
      className={`fre_bx ${activeFaqIndex === index ? "active" : ""}`}
      onClick={() => handleFaqClick(index)}
      role="button" 
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") handleFaqClick(index);
      }

    >
      
      <h3>{faq.question}</h3>
      <p>{faq.answer}</p>
    </div>
  ))} */}
          </div>
        </div>
      </section>
      <ContactUs isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </>
  );
}

export default ServicesDetails;
